import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  TransactionOutlined,
  CoffeeOutlined,
  FileOutlined,
  PrinterOutlined,
  SettingOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { API_METHODS } from "../constants";
import useApi from "../hooks/useApi";
import { setDataToLocalStorage } from "../generalFunctions";
import logo from "../assests/images/logo.png";
import Dashboard from "./Dashboard";
import UserTable from "./config/user/UserTable";
import CaptionTable from "./config/caption/CaptionTable";
import PublicationTable from "./config/publication/PublicationTable";
import ReferencePartyTable from "./config/reference party/ReferencePartyTable";
// import GSTTable from "./config/gst/GSTTable";
import VoucherTypeTable from "./config/voucher type/VoucherTypeTable";
// import AdTypeTable from "./config/ad type/AdTypeTable";
// import AccountTypeTable from "./config/account type/AccountTypeTable";
import AccountTable from "./config/account/AccountTable";
import ReleaseOrderTable from "./config/release order/ReleaseOrderTable";
import CreditNoteTable from "./transactions/creditNote/CreditNoteTable";
import DebitNoteTable from "./transactions/debitNote/DebitNoteTable";
import PartyBillTable from "./config/party bill/PartyBillTable";
import AddPartyBill from "./config/party bill/AddPartyBill";
import AddReceipt from "./config/receipt/AddReceipt";
import ReceiptTable from "./config/receipt/ReceiptTable";
import PublicationBillTable from "./transactions/publicationBill/PublicationBillTable";
import AddPublicationBill from "./transactions/publicationBill/AddPublicationBill";
import DateRangeWisePrinting from "./common/DateRangeWisePrinting";
import BillwisePaymentTable from "./transactions/billwisePayment/BillwisePaymentTable";
import AddBillwisePayment from "./transactions/billwisePayment/AddBillwisePayment";
import DebitNoteBillwiseTable from "./transactions/debitNoteBillwise/DebitNoteBillwiseTable";
import AddDebitNoteBillwise from "./transactions/debitNoteBillwise/AddDebitNoteBillwise";
import DirectPurchaseTable from "./transactions/directPurchase/DirectPurchaseTable";
import Report from "./reports/Reports";
import OnAccountPaymentTable from "./transactions/onAccountPayment/OnAccountPaymentTable";
import AddOnAccountPayment from "./transactions/onAccountPayment/AddOnAccountPayment";

const { Header, Sider, Content } = Layout;

function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [clientConfig, getClientConfig] = useApi(
    "/config",
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getClientConfig();
  }, []);

  useEffect(() => {
    if (clientConfig.data) {
      setDataToLocalStorage("clientConfig", clientConfig.data);
      if (location.pathname === "/portal") {
        navigate("/portal/dashboard");
      }
    }
  }, [clientConfig]);

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logoutClicked = () => {
    //TODO: api call for token cancellation
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("clientConfig");
    navigate("/");
  };

  // const isAdmin = () => {
  //   if (JSON.parse(localStorage.getItem("user")).role === 1) return true
  //   else return false
  // }

  const refreshClientConfig = () => {
    getClientConfig();
  };

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <img style={{ height: 50, width: "100%" }} src={logo} />
        </div>
        <Menu theme="light" mode="inline" defaultSelectedKeys={["1"]}>
          <Menu.Item key="1" icon={<HomeOutlined />}>
            <Link to="dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.SubMenu key="2" icon={<SettingOutlined />} title="Settings">
            <Menu.Item key="200">
              <Link to="account">Account</Link>
            </Menu.Item>
            {/* <Menu.Item key="201">
              <Link to="accountType">Account Types</Link>
            </Menu.Item> */}
            <Menu.Item key="202">
              <Link to="user">User</Link>
            </Menu.Item>
            <Menu.Item key="203">
              <Link to="caption">Caption</Link>
            </Menu.Item>
            <Menu.Item key="204">
              <Link to="publication">Publication</Link>
            </Menu.Item>
            <Menu.Item key="205">
              <Link to="refParty">Reference Party</Link>
            </Menu.Item>
            {/* <Menu.Item key="206">
              <Link to="gst">GST Rate</Link>
            </Menu.Item> */}
            <Menu.Item key="207">
              <Link to="voucherType">Voucher Type</Link>
            </Menu.Item>
            {/* <Menu.Item key="208">
              <Link to="adType">Ad Type</Link>
            </Menu.Item> */}
          </Menu.SubMenu>
          <Menu.SubMenu
            key="3"
            icon={<TransactionOutlined />}
            title="Transactions"
          >
            <Menu.Item key="301">
              <Link to="releaseOrder">Release Order</Link>
            </Menu.Item>
            <Menu.Item key="300">
              <Link to="releaseOrderClassified">Classified RO</Link>
            </Menu.Item>
            <Menu.Item key="302">
              <Link to="partyBill">Party Bill</Link>
            </Menu.Item>
            <Menu.Item key="311">
              <Link to="partyBillClassified">Classified Party Bill</Link>
            </Menu.Item>

            <Menu.Item key="305">
              <Link to="receipt">Receipt</Link>
            </Menu.Item>
            <Menu.Item key="306">
              <Link to="publicationBill">Publication Bill</Link>
            </Menu.Item>
            <Menu.Item key="307">
              <Link to="billwisePayment">Billwise Payment</Link>
            </Menu.Item>
            <Menu.Item key="303">
              <Link to="creditNote">Credit Note</Link>
            </Menu.Item>
            <Menu.Item key="304">
              <Link to="debitNote">Debit Note</Link>
            </Menu.Item>
            <Menu.Item key="308">
              <Link to="debitNoteBillwise">Debit Note Billwise</Link>
            </Menu.Item>
            <Menu.Item key="309">
              <Link to="directPurchase">Direct Purchase</Link>
            </Menu.Item>
            <Menu.Item key="310">
              <Link to="onAccountPayment">On Account Payment</Link>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.Item key="4" icon={<FileOutlined />}>
            <Link to="reports">Reports</Link>
          </Menu.Item>
          <Menu.Item key="5" icon={<PrinterOutlined />}>
            <Link to="dateRangeWisePrinting">Bulk Printing</Link>
          </Menu.Item>
          <Menu.Item key="7" icon={<LogoutOutlined />} onClick={logoutClicked}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout
        className="site-layout"
        style={{
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Header className="site-layout-background" style={{ padding: 0 }}>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: toggle,
            }
          )}
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
          }}
        >
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/user"
              element={<UserTable refreshClientConfig={refreshClientConfig} />}
            />
            <Route
              path="/caption"
              element={
                <CaptionTable refreshClientConfig={refreshClientConfig} />
              }
            />
            <Route
              path="/publication"
              element={
                <PublicationTable refreshClientConfig={refreshClientConfig} />
              }
            />
            <Route
              path="/refParty"
              element={
                <ReferencePartyTable
                  refreshClientConfig={refreshClientConfig}
                />
              }
            />
            {/* <Route
              path="/gst"
              element={<GSTTable refreshClientConfig={refreshClientConfig} />}
            /> */}
            <Route
              path="/voucherType"
              element={
                <VoucherTypeTable refreshClientConfig={refreshClientConfig} />
              }
            />
            {/* <Route
              path="/adType"
              element={
                <AdTypeTable refreshClientConfig={refreshClientConfig} />
              }
            /> */}
            {/* <Route
              path="/accountType"
              element={
                <AccountTypeTable refreshClientConfig={refreshClientConfig} />
              }
            /> */}
            <Route
              path="/account"
              element={
                <AccountTable refreshClientConfig={refreshClientConfig} />
              }
            />
            <Route
              path="/releaseOrder"
              element={<ReleaseOrderTable isClassified={0} />}
            />
            <Route
              path="/releaseOrderClassified"
              element={<ReleaseOrderTable isClassified={1} />}
            />
            <Route path="/creditNote" element={<CreditNoteTable />} />
            <Route path="/debitNote" element={<DebitNoteTable />} />
            <Route
              path="/partyBill"
              element={<PartyBillTable isClassified={0} />}
            />
            <Route
              path="/partyBillClassified"
              element={<PartyBillTable isClassified={1} />}
            />
            <Route
              path="/partyBill/add"
              element={<AddPartyBill isClassified={0} />}
            />
            <Route
              path="/partyBill/edit"
              element={<AddPartyBill isClassified={0} />}
            />
            <Route
              path="/partyBill/view"
              element={<AddPartyBill isClassified={0} />}
            />
            <Route
              path="/partyBillClassified/add"
              element={<AddPartyBill isClassified={1} />}
            />
            <Route
              path="/partyBillClassified/edit"
              element={<AddPartyBill isClassified={1} />}
            />
            <Route
              path="/partyBillClassified/view"
              element={<AddPartyBill isClassified={1} />}
            />
            <Route path="/receipt" element={<ReceiptTable />} />
            <Route path="/receipt/add" element={<AddReceipt />} />
            <Route path="/receipt/edit" element={<AddReceipt />} />
            <Route path="/receipt/view" element={<AddReceipt />} />
            <Route path="/publicationBill" element={<PublicationBillTable />} />
            <Route
              path="/publicationBill/add"
              element={<AddPublicationBill />}
            />
            <Route
              path="/publicationBill/edit"
              element={<AddPublicationBill />}
            />
            <Route
              path="/publicationBill/view"
              element={<AddPublicationBill />}
            />
            <Route path="/billwisePayment" element={<BillwisePaymentTable />} />

            <Route
              path="/billwisePayment/add"
              element={<AddBillwisePayment />}
            />
            <Route
              path="/billwisePayment/edit"
              element={<AddBillwisePayment />}
            />
            <Route
              path="/billwisePayment/view"
              element={<AddBillwisePayment />}
            />

            <Route
              path="/dateRangeWisePrinting"
              element={<DateRangeWisePrinting />}
            />
            <Route
              path="/debitNoteBillwise"
              element={<DebitNoteBillwiseTable />}
            />
            <Route
              path="/debitNoteBillwise/add"
              element={<AddDebitNoteBillwise />}
            />
            <Route
              path="/debitNoteBillwise/edit"
              element={<AddDebitNoteBillwise />}
            />
            <Route
              path="/debitNoteBillwise/view"
              element={<AddDebitNoteBillwise />}
            />
            <Route path="/directPurchase" element={<DirectPurchaseTable />} />
            <Route path="/reports" element={<Report />} />

            <Route
              path="/onAccountPayment"
              element={<OnAccountPaymentTable />}
            />
            <Route
              path="/onAccountPayment/add"
              element={<AddOnAccountPayment />}
            />
            <Route
              path="/onAccountPayment/edit"
              element={<AddOnAccountPayment />}
            />
            <Route
              path="/onAccountPayment/view"
              element={<AddOnAccountPayment />}
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
